// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ca4cb7c9","239":"d1e90b75","455":"937bca7b","488":"53c6c15c","797":"097e15eb"}[chunkId] + ".chunk.js";
};